import { UniversalCrud, UniversalDetail } from "@stdoutsrl/design-kit";
import { CompanyProductSuggestionComponent } from "../tables-custom-actions/company-product-suggestion.component";
import { CreateCompanyComponent } from "../tables-custom-actions/create-company.component";
import { CreateOperatorComponent } from "../tables-custom-actions/create-operator.component";
import { DownloadSalesExcelComponent } from "../tables-custom-actions/download-sales-excel.component";
import { EditOperatorComponent } from "../tables-custom-actions/edit-operator.component";
import { MinusWarehouseProductComponent } from "../tables-custom-actions/minus-warehouse-product.component";
import { PlusWarehouseProductComponent } from "../tables-custom-actions/plus-warehouse-product.component";
import { ProductAssociationComponent } from "../tables-custom-actions/product-association.component";
import { UsersForceResetPasswordComponent } from "../tables-custom-actions/users-force-reset-password.component";
import { api, environment } from "../../environments/environment";
import { DetailOperatorComponent } from "../tables-custom-actions/detail-operator.component";

export const categories: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Categorie", route: "/categorie" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  tableTitle: "categories",
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
  ],
  endpoint: "/categories",
};

export const subCategories: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Sotto Categorie", route: "/sotto-categorie" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  tableTitle: "subCategories",
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
  ],
  endpoint: "/categories",
};

export const subscriptions: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Sottoscrizioni", route: "/sottoscrizioni" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  tableTitle: "subscriptions",
  table: [
    {
      element: "companyId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      bindValueSelect: "id",
      bindLabelSelect: "companyName",
      tableElementToVisualize: [{ paths: ["company", "companyName"], useFixedValue: false }],
      selectDataEndpoint: "/company/all",
    },
    {
      element: "planId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      tableElementToVisualize: [{ paths: ["plan", "name"], useFixedValue: false }],
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/plan/all",
    },
    {
      element: "plans",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },

    {
      element: "salons",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "store",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "analytics",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "salons",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "plans",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "startDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date",
    },
    {
      element: "endDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date",
    },
    {
      element: "status",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      prefixTranslateValue: "subStatus.",
      selectArray: [
        {
          label: "Disattivato",
          value: 0,
        },
        {
          label: "Attivo",
          value: 1,
        },
      ],
    },
    {
      element: "payInApp",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "store",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
  ],
  endpoint: "/subscription",
};

export const planDescriptions: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Descrizione piani", route: "/descrizione-piani" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  useFormData: false,
  tableTitle: "planDescriptions",
  table: [
    {
      element: "planId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      tableElementToVisualize: [{ paths: ["plan", "name"], useFixedValue: false }],
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/plan/all",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "enable",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
  ],
  endpoint: "/plan-description",
};

export const plan: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Piani", route: "/piani" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  useFormData: false,
  tableTitle: "plans",
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "plans",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "referralSale",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "salons",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "store",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "analytics",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "payInApp",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "Pagamenti non presenti" },
        { value: true, label: "Pagamenti presenti" },
      ],
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "duration",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      prefixTranslateValue: "planDuration.",
      selectArray: [
        { value: 1, label: "Mensile" },
        { value: 12, label: "Annuale" },
      ],
    },
  ],
  endpoint: "/plan",
};

export const users: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Utenti", route: "/utenti" }],
  canAddElement: true,
  requirePut: true,
  canEditElement: true,
  canDeleteElement: true,
  tableTitle: "users",
  customTableActions: [
    {
      component: UsersForceResetPasswordComponent,
      icon: "../../assets/send-recovery.svg",
      iconClass: "",
    },
  ],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "phone",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "code",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "role",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectArray: [
        {
          value: 1,
          label: "Utente",
        },
        {
          value: 2,
          label: "Salone",
        },
        {
          value: 3,
          label: "Azienda",
        },
        {
          value: 4,
          label: "Admin",
        },
        {
          value: 5,
          label: "Rivenditore",
        },
      ],
      translateValue: true,
      prefixTranslateValue: "roles.",
    },
  ],
  endpoint: "/user",
};

export const resellerWarehouses: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: false,
  breadcrumb: [{ title: "resellerWarehouses", route: "/reseller-warehouses" }],
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
  tableTitle: "warehouse",
  table: [
    {
      element: "companyId",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "companyName",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
  ],
  endpoint: "/sales/company/store-stock",
};

export const bundle: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Pacchetti", route: "/pacchetti" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  endpoint: "/bundle",
  tableTitle: "bundle",
  baseFilters: [
    {
      endpoint: "/user/me/salon",
      value: "salonId",
      type: "select",
      obligatory: true,
      label: "selectSalon",
      placeholder: "selectSalon",
      bindValue: "id",
      bindLabel: "name",

      valueForSelect: "id",
      isPaginated: false,
    },
  ],
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "salonId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/user/me/salon",
    },
    {
      element: "itemId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/item/all",
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "last",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "quantity",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "active",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
  ],
};

export const companies: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Aziende", route: "/aziende" }],
  canAddElement: false,
  canEditElement: true,
  canDeleteElement: true,
  tableTitle: "companies",
  customActions: [
    {
      component: CreateCompanyComponent,
      label: "Aggiungi azienda",
      translateLabel: false,
    },
  ],
  table: [
    {
      element: "companyName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "vat",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },

    {
      element: "phoneNumber",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "address",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "city",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "zipcode",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "state",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "country",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "tax",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "email",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "pec",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "sdi",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
  ],
  details: { route: "companyPath" },
  endpoint: "/company",
};

export const customers: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  breadcrumb: [{ title: "Clienti", route: "/clienti" }],
  canAddElement: false,
  isFatherValueArray: true,
  useFormData: true,
  isPaginated: true,
  canEditElement: false,
  canDeleteElement: false,
  tableTitle: "customers",
  table: [
    {
      element: "firstName",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "phone",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "email",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
  ],
  endpoint: "/user/customers",
};

export const salons: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  breadcrumb: [{ title: "Saloni", route: "/saloni" }],
  canAddElement: true,
  // fatherEndpoint: "/user/me/company",
  fatherValue: "id",
  isFatherValueArray: true,
  isPaginated: true,
  useFormData: true,
  elementToRemove: ["company", "companyId"],
  fatherExtraEndpoint: "/company/",
  canEditElement: true,
  canDeleteElement: true,
  tableTitle: "salons",
  // maxItems: "getSalonMaxItems",
  table: [
    {
      element: "file",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
      tableElementToVisualize: [{ paths: ["image"], useFixedValue: false }],
    },

    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "address",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "city",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "phoneNumber",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "zipcode",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "state",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "country",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "email",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
  ],
  details: {
    route: "route.salon",
  },
  endpoint: "/salon",
};

export const services: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "Servizi", route: "/servizi" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  fatherValue: "id",
  isFatherValueArray: true,
  tableTitle: "services",
  table: [
    {
      element: "file",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
      tableElementToVisualize: [{ paths: ["image"], useFixedValue: false }],
    },
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number",
    },
    {
      element: "name",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "categoryId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      tableElementToVisualize: [{ paths: ["category", "name"], useFixedValue: false }],
      bindLabelSelect: "name",
      bindValueSelect: "id",
      selectDataEndpoint: "/categories/all",
    },
  ],
  endpoint: "/item",
};

export const suggestedProducts: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "Prodotti suggeriti", route: "/prodotti-suggeriti" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  fatherValue: "id",
  useFormData: true,
  isFatherValueArray: true,
  elementToRemove: ["company", "companyId"],
  fatherExtraEndpoint: "/company/",
  tableTitle: "products",
  endpoint: "/item-suggested",
  table: [
    {
      element: "file",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
      tableElementToVisualize: [{ paths: ["image"], useFixedValue: false }],
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      prefixTranslateValue: "typeProduct.",
      selectArray: [{ value: 1, label: "Prodotto" }],
    },
    {
      element: "serviceId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectDataEndpoint: "/subcategories/all",
      bindLabelSelect: "name",
      bindValueSelect: "id",
    },
    {
      element: "duration",
      label: "durationMinute",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "days",
      label: "daysReminder",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "categoryId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      tableElementToVisualize: [{ paths: ["category", "name"], useFixedValue: false }],
      bindLabelSelect: "name",
      bindValueSelect: "id",
      selectDataEndpoint: "/categories/all",
    },
  ],
};

export const products: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "Prodotti", route: "/prodotti" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  fatherValue: "id",
  useFormData: true,
  isFatherValueArray: true,
  elementToRemove: ["company", "companyId"],
  fatherExtraEndpoint: "/company/",
  tableTitle: "products",
  customTableActions: [
    {
      component: ProductAssociationComponent,
      icon: "../../assets/eyeWhite.svg",
      iconClass: "",
    },
  ],
  table: [
    {
      element: "file",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
      tableElementToVisualize: [{ paths: ["image"], useFixedValue: false }],
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      prefixTranslateValue: "typeProduct.",
      selectArray: [{ value: 1, label: "Prodotto" }],
    },
    {
      element: "serviceId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectDataEndpoint: "/subcategories/all",
      bindLabelSelect: "name",
      bindValueSelect: "id",
    },
    {
      element: "duration",
      label: "durationMinute",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "days",
      label: "daysReminder",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "categoryId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      tableElementToVisualize: [{ paths: ["category", "name"], useFixedValue: false }],
      bindLabelSelect: "name",
      bindValueSelect: "id",
      selectDataEndpoint: "/categories/all",
    },
  ],
  endpoint: "/item",
};

export const coupons: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "Coupon", route: "/coupon" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  fatherValue: "id",
  useFormData: false,
  baseFilters: [
    {
      endpoint: "/user/me/salon",
      value: "salonId",
      type: "select",
      obligatory: true,
      label: "selectSalon",
      placeholder: "selectSalon",
      bindValue: "id",
      bindLabel: "name",

      valueForSelect: "id",
      isPaginated: false,
    },
  ],
  isFatherValueArray: true,
  tableTitle: "coupon",
  endpoint: "/coupon",
  table: [
    {
      element: "salonId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/user/me/salon",
    },
    {
      element: "startDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date",
    },
    {
      element: "endDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date",
    },
    {
      element: "discount",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "occurrences",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "used",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "couponCode",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
  ],
};

export const promotions: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "Promozioni", route: "/promozioni" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  fatherValue: "id",
  useFormData: false,
  baseFilters: [
    {
      endpoint: "/user/me/salon",
      value: "salonId",
      type: "select",
      obligatory: true,
      label: "selectSalon",
      placeholder: "selectSalon",
      bindValue: "id",
      bindLabel: "name",

      valueForSelect: "id",
      isPaginated: false,
    },
  ],
  isFatherValueArray: true,
  tableTitle: "promotions",
  endpoint: "/promotion",
  table: [
    {
      element: "salonId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/user/me/salon",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "startDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date",
    },
    {
      element: "endDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date",
    },
    {
      element: "discount",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "occurrences",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
  ],
};

export const warehouse: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "Magazzino", route: "/magazzino" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  fatherValue: "id",
  useFormData: true,
  baseFilters: [
    {
      endpoint: "/user/me/salon",
      value: "salonId",
      type: "select",
      obligatory: true,
      label: "selectSalon",
      placeholder: "selectSalon",
      bindValue: "id",
      bindLabel: "name",

      valueForSelect: "id",
      isPaginated: false,
    },
  ],
  isFatherValueArray: true,
  tableTitle: "warehouse",
  customTableActions: [
    {
      component: PlusWarehouseProductComponent,
      icon: "../../assets/plus.svg",
      iconClass: "",
    },
    {
      component: MinusWarehouseProductComponent,
      icon: "../../assets/minus.svg",
      iconClass: "",
    },
  ],

  table: [
    {
      element: "file",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
      tableElementToVisualize: [{ paths: ["image"], useFixedValue: false }],
    },
    {
      element: "stock",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "salonId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      bindValueSelect: "id",
      bindLabelSelect: "name",
      selectDataEndpoint: "/user/me/salon",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "barcode",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "listPrice",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number",
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number",
    },
    {
      element: "category",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "duration",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number",
    },
    {
      element: "brand",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
  ],
  endpoint: "/store",
};

export const sales: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Vendite", route: "/vendite" }],
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
  tableTitle: "booking-summary-view",
  customActions: [
    {
      component: DownloadSalesExcelComponent,
      label: "downloadSalesExcel",
      translateLabel: true,
      icon: "",
      iconClass: "",
    },
  ],
  table: [
    {
      element: "itemName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number",
    },
    {
      element: "userFirstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "userLastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "type",
      table: true,
      editable: true,
      translateValue: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectArray: [
        {
          label: "Sconosciuto",
          value: "unknown",
        },
        {
          label: "Prodotto",
          value: "product",
        },
        {
          label: "Servizio",
          value: "service",
        },
      ],
    },
    {
      element: "purchaseDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date",
    },
  ],
  endpoint: "/booking-summary-view",
};

export const operators: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: true,
  addExtraEndpointAfterEndpoint: "/paginate",
  breadcrumb: [{ title: "Operatori", route: "/operator" }],
  canAddElement: false,
  canEditElement: true,
  canDeleteElement: true,

  tableTitle: "operators",
  endpoint: "/operator",
  table: [
    {
      element: "file",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
      tableElementToVisualize: [{ paths: ["image"], useFixedValue: false }],
    },
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number",
    },
    {
      element: "showInApp",
      table: true,
      editable: true,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "select",
      selectArray: [
        {
          label: "Chiuso",
          value: 0,
        },
        {
          label: "Aperto",
          value: 1,
        },
      ],
      translateValue: true,
      prefixTranslateValue: "showInAppSelect.",
    },
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
  ],
};

export const operator: UniversalDetail = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  details: operators.table,
  currentBreadcrumb: 1,

  breadcrumb: [
    { title: "Operatori", route: "/operatori" },
    { title: "Operatore", route: "/operatore" },
  ],
  tables: [
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "timetables",
      name: "timetables",
      customAddLabel: "addTimeTable",
      active: true,
      table: [
        {
          element: "day",
          table: true,
          editable: true,
          translateValue: true,
          prefixTranslateValue: "daysOfTheWeek.",
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
        },
        {
          element: "timeStart",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "time",
        },
        {
          element: "timeEnd",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "time",
        },
        {
          element: "salonId",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          bindValueSelect: "id",
          bindLabelSelect: "name",
          selectDataEndpoint: "/user/me/salon",
        },
      ],
    },
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "days",
      name: "days",
      active: false,
      table: [
        {
          element: "day",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
        },
        {
          element: "status",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Chiuso",
              value: 0,
            },
            {
              label: "Aperto",
              value: 1,
            },
          ],
        },
        {
          element: "from",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "date",
        },
        {
          element: "recurring",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            { value: 0, label: "No" },
            { value: 1, label: "Si" },
          ],
        },
      ],
    },
  ],
  endpoint: "/operator",
};

export const salon: UniversalDetail = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  details: salons.table,
  currentBreadcrumb: 1,

  breadcrumb: [
    { title: "Saloni", route: "/saloni" },
    { title: "Salone", route: "/salone" },
  ],
  tables: [
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "timetables",
      name: "timetables",
      customAddLabel: "addTimeTable",
      active: true,

      table: [
        {
          element: "day",
          table: true,
          editable: true,
          translateValue: true,
          prefixTranslateValue: "daysOfTheWeek.",
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
        },
        {
          element: "timeStart",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "time",
        },
        {
          element: "timeEnd",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "time",
        },
      ],
    },
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "days",
      name: "days",
      active: false,
      table: [
        {
          element: "day",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
        },
        {
          element: "status",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Chiuso",
              value: 0,
            },
            {
              label: "Aperto",
              value: 1,
            },
          ],
        },
        {
          element: "from",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "date",
        },
        {
          element: "recurring",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            { value: 0, label: "No" },
            { value: 1, label: "Si" },
          ],
        },
      ],
    },
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "dates",
      name: "dates",
      active: false,
      table: [
        {
          element: "date",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "date",
        },
        {
          element: "status",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Chiuso",
              value: 0,
            },
            {
              label: "Aperto",
              value: 1,
            },
          ],
        },
      ],
    },
    {
      canAddElement: false,
      canEditElement: true,
      canDeleteElement: false,
      single: true,
      endpoint: "salon-notification-settings",
      name: "notifications",
      active: false,
      table: [
        {
          element: "salon_id",
          table: false,
          editable: false,
          creation: false,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "number",
        },
        {
          element: "email_hours_before",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "number",
        },
        {
          element: "push_hours_before",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "number",
        },
        {
          element: "notify_salon",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          translateValue: true,
          prefixTranslateValue: "",
          type: "select",
          selectArray: [
            { value: false, label: "Non mandare email" },
            { value: true, label: "Mandare email" },
          ],
        },
      ],
    },
  ],
  endpoint: "/salon",
};

export const resellers: UniversalCrud = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  isPaginated: false,
  breadcrumb: [{ title: "Rivenditori", route: "/rivenditori" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  useFormData: true,
  tableTitle: "resellers",
  endpoint: "/sale",
  table: [
    {
      element: "banner_login",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
    },
    {
      element: "logo_login",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
    },
    {
      element: "logo_sidenav",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "image",
    },
    {
      element: "domain",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "primary",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "color",
    },
    {
      element: "secondary",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "color",
    },
    {
      element: "tertiary",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "color",
    },
    {
      element: "quaternary",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "color",
    },
    {
      element: "userId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
  ],
};

export const company: UniversalDetail = {
  environment: environment,
  api: api,
  step5Minutes: true,
  showClock: false,
  use24h: true,
  details: companies.table,
  currentBreadcrumb: 1,

  breadcrumb: [
    { title: "Aziende", route: "/aziende" },
    { title: "Azienda", route: "/azienda" },
  ],
  tables: [
    {
      canAddElement: true,
      canEditElement: false,
      canDeleteElement: false,
      endpoint: "auth/manager",
      customEndpoints: {
        create: ['auth/manager'],
        read: ['company/managers/list'],
        delete: ['auth/manager'],
        update: ['auth/manager'],
      },
      name: "managers",
      useFormData: false,
      active: false,
      table: [
        {
          element: "id",
          table: true,
          editable: false,
          creation: false,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "number",
        },
        {
          element: "firstName",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "text",
          tableElementToVisualize: [{
            useFixedValue: false,
            paths: ['firstName']
          }, {
            useFixedValue: true,
            paths: [' ']
          }, {
            useFixedValue: false,
            paths: ['lastName']
          }]
        },
        {
          element: "lastName",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "text",
        },
        {
          element: "email",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "text",
        },
        {
          element: "salonId",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          bindValueSelect: "id",
          bindLabelSelect: "name",
          selectDataEndpoint: "/user/me/salon",
        },
        {
          element: "password",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "text",
        },
      ],
    },
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "salon",
      name: "salon",
      useFormData: true,
      active: false,
      table: salons.table,
      elementToRemove: ["company", "companyId"],
    },
    {
      canAddElement: false,
      canEditElement: false,
      canDeleteElement: true,
      useFormData: true,
      endpoint: "operator",
      name: "operator",
      active: false,
      table: operators.table,
      customActions: [
        {
          component: CreateOperatorComponent,
          label: "addOperator",
          translateLabel: true,
        },
      ],
      customTableActions: [
        {
          component: EditOperatorComponent,
          icon: "../../assets/pencil.svg",
          iconClass: "",
        },
        {
          component: DetailOperatorComponent,
          icon: "../../assets/eyeWhite.svg",
          iconClass: "",
        },
      ],
    },
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "item",
      useFormData: true,
      name: "item",
      active: true,
      customActions: [
        {
          component: CompanyProductSuggestionComponent,
          label: "useSuggestedProduct",
          translateLabel: true,
          icon: "",
          iconClass: "",
        },
      ],
      table: products.table,
    },
  ],
  endpoint: "/company",
};
